<!-- =========================================================================================
		File Name: KnowledgeBase.vue
		Description: Knowledge Base Page
		----------------------------------------------------------------------------------------
		Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
			Author: Pixinvent
		Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="knowledge-base-page">
    <div class="mb-2" v-for="error in types_errors" :key="error.message">
      <vs-alert color="danger" icon="new_releases"
        ><span>{{ error }}</span></vs-alert
      >
    </div>
    <div class="vs-row">
      <template v-if="types.length">
        <div
          class="vs-col mb-2 p-2 match-height"
          v-for="(type, index) in types"
          :key="`article_type_${index}_${selected_type.id}_${type_key}`"
        >
          <vs-button
            class="p-5 w-full match-height"
            :type="`${selected_type.name == type.name ? 'filled' : 'border'}`"
            @click="(selected_type = type), retrieveArticleGroup()"
          >
            <p :class="`${selected_type.name == type.name ? 'text-white font-bold' : ''}`">
              {{ type.name }}
            </p>
          </vs-button>
        </div>
      </template>
    </div>
    <div class="vx-col w-full" v-if="types.length < 1">
      <div class="text-center">
        <i>--- {{ $t("general.notAvailable", { msg: $t("attribute.helpCenter") }) }} ---</i>
      </div>
    </div>
    <vs-divider></vs-divider>
    <div class="vx-col w-full">
      <!-- KNOWLEDGE BASE CARDS  -->
      <div class="vx-row match-height" v-if="selected_type.type != 'WHATS_NEW_SECTION' && selected_type.is_active">
        <template v-if="list.length > 0">
          <div
            class="vx-col w-full md:w-1/4 sm:w-1/2 mb-base"
            v-for="item in list"
            :key="item.id"
            @click="navigateGroup(item.id)"
          >
            <help-center-group-component :data="item" :showArticles="false"></help-center-group-component>
          </div>
        </template>
      </div>
      <div class="vx-row" v-if="selected_type.type == 'WHATS_NEW_SECTION'">
        <div class="vx-col w-full">
          <ul class="bordered-items mt-4">
            <li v-for="que in article_list" :key="que.slug" class="py-2 cursor-pointer" @click="onClickArticle(que)">
              <h4 class="font-bold">{{ que.title }}</h4>
              <small class="mt-2 activity-desc"
                >{{ $t("attribute.lastUpdated") }} : {{ renderToHumanDate(que.updated_at) }}</small
              >
            </li>
          </ul>
        </div>
      </div>
      <div v-if="!selected_type.is_active && selected_type.type !== 'WHATS_NEW_SECTION'">
        <div class="vx-col w-full mt-5">
          <div class="text-center">
            <h4>{{ $t("helpCenter.clickLiveChat") }}!</h4>
          </div>
          <div class="text-center mt-2 mb-base">
            <vs-button type="filled" @click="navigateToLiveChat()">{{
              $t("attribute.liveChat").toUpperCase()
            }}</vs-button>
          </div>
        </div>
        <div class="vx-col text-center mb-3">
          <div class="vx-row">
            <div class="vx-col md:w-2/5">&nbsp;</div>
            <img
              src="/images/ilust/handbook.png"
              title="Live Chat Ilustration"
              alt="Live Chat Ilustration"
              class="vx-col md:w-1/5"
            />
            <div class="vx-col md:w-2/5">&nbsp;</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Crypto from "@/helper/crypto";
import ErrorHandler from "@/helper/error_handler";
import Global from "@/helper/global";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";

export default {
  data() {
    return {
      api_errors: [],
      types_errors: [],
      list: [],
      selected_type: {
        id: null,
        name: null,
        is_active: false,
      },
      types: [],
      type_key: 1,
      article_list: [],
      isAuth: false,
    };
  },
  components: {
    VueSimpleSuggest,
  },
  created() {
    this.isAuth = this.$store.getters.isLoggedIn;
  },
  mounted() {
    this.retrieveArticleType();
  },
  methods: {
    navigateGroup(groupId) {
      this.$router.push({
        name: this.isAuth ? "customer-help-center-group" : "public-help-center-group",
        params: {
          group_id: groupId,
        },
      });
    },
    navigateToLiveChat() {
      window.open(this.$endpoints.hostname + "/livechat", "_blank");
    },
    retrieveArticleType() {
      this.types_errors = [];

      this.$vs.loading({
        type: "radius",
      });

      let url = this.$endpoints.article_type;
      let params = {
        is_auth: this.isAuth,
        is_customer: this.$store.getters.isCustomer || false,
        //is_driver: this.$store.getters.isDriver || false,
        is_driver: false,
      };

      this.$http
        .get(url, { params: params })
        .then((res) => {
          this.types = res.data.data;

          if (this.types.length) {
            this.selected_type = this.types[0];
            this.type_key++;
            this.retrieveArticleGroup();
          }
        })
        .catch((err) => {
          this.types_errors = ErrorHandler.processErrorMessage(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    retrieveArticleGroup() {
      this.api_errors = [];

      this.$vs.loading({
        type: "radius",
      });

      let url = this.$endpoints.article_type + "/" + this.selected_type.id + "/group";

      this.$http
        .get(url)
        .then((res) => {
          this.$store.dispatch("updateSelectedHelpCenter", this.selected_type);
          this.list = res.data.data;
        })
        .catch((err) => {
          this.api_errors = ErrorHandler.processErrorMessage(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    onClickArticle(article) {
      if ("slug" in article) {
        let routeData = this.$router.resolve({
          name: "customer-help-center-article",
          params: {
            slug: article.slug,
            data: article,
          },
        });
        window.open(routeData.href, "_blank");
      }
    },
    renderToHumanDate(datetime) {
      return Global.renderToHumanDate(datetime);
    },
  },
};
</script>
